import { Card } from '@sonnen/web-ui';
import { USPTypography } from '../USPTypography/USPTypography';
import styles from './CustomUSPCard.module.css';

type CustomUSPCardProps = {
  i18nScope:
    | 'selfConsumptionPlus.sonnenAppCard'
    | 'home.cardChart'
    | 'home.cardSmartMeter'
    | 'home.priceOptimizationTeaserCard'
    | 'tariffOverview.energyFix.cardSonnenApp';
  children?: React.ReactNode;
  dataTestId?: string;
};

export const CustomUSPCard = ({ i18nScope, children, dataTestId = 'usp' }: CustomUSPCardProps) => (
  <Card dataTestId={dataTestId} paddingSize="none">
    <Card withBottomSpace={false} paddingSize="md">
      <div className={styles.text}>
        <USPTypography i18nScope={i18nScope} />
      </div>
    </Card>
    {children}
  </Card>
);
